<div class="timer">
    <span id="seconds"> {{secondsToDday | minuteSeconds}} </span>Minutes
</div>